
// Countdown time to destinationDate.
/*
// USAGE:

  import countdown from "countdown";
  ...

  const display = document.getElementById("display");

  const cancelTimer = countdown("2022-01-18 20:00:00", time => {    
    console.log(time.days, time.hours, time.minutes, time.secons);
    display.innerHTML = time.toString();
  });

  // To cancel contdown; 
  cancelTimer();

*/

export default function countdown(destinationDate, update) {

  const countDownDate = new Date(destinationDate.replace(/ /g, "T")).getTime();
  const timer = setInterval(function () {
    const now = new Date().getTime();
    const timeleft = countDownDate - now;

    const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    timeleft > 0
      ? update(new Time(days, hours, minutes, seconds))
      : cancelTimer();

  }, 1000);

  function Time(d, h, m, s) {
    this.days = leadingZero(d);
    this.hours = leadingZero(h);
    this.minutes = leadingZero(m);
    this.seconds = leadingZero(s);
  }

  Time.prototype.toString = function (params) {
    return `${this.days}:${this.hours}:${this.minutes}:${this.seconds}`;
  }

  function leadingZero(value) {
    return value < 10 ? `0${value}` : `${value}`;
  }

  function cancelTimer() {
    clearInterval(timer);
    update(new Time(0, 0, 0, 0));
  }

  return cancelTimer;
}
